import "./proxy-connect.css";
import { useState } from "react";
import { legacyDesk, proxyAsk, syncProxyDesk } from "./proxyDesk";
export function ProxyConnect() {
  const [open, setOpen] = useState(
    new URLSearchParams(location.search).has("autoopen"),
  );
  const [code, setCode] = useState(""),
    [message, setMessage] = useState(""),
    [busy, setBusy] = useState(false);
  async function pair() {
    setBusy(true);
    const r = await proxyAsk({ op: "pair", code: code.trim().toUpperCase() });
    setMessage(
      r.ok
        ? "Сканер подключён. Назначь профили и подготовь рабочее место в приложении."
        : r.error,
    );
    setCode("");
    if (r.ok) await syncProxyDesk();
    setBusy(false);
  }
  async function migrate() {
    setBusy(true);
    const c = legacyDesk();
    const r = await proxyAsk({
      op: "import",
      books: c.books || {},
      pair: c.pair || [],
    });
    setMessage(
      r.ok
        ? "Предпросмотр импорта открыт в FORQ Proxy → Автооткрытие. Проверь назначения перед применением."
        : r.error,
    );
    setBusy(false);
  }
  return (
    <>
      {open && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="Подключение автооткрытия"
          className="nx-proxy-dialog"
        >
          <div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Закрыть"
            >
              ×
            </button>
            <h2>Автооткрытие в FORQ Proxy</h2>
            <p>
              Конторы, профили и маршруты настраиваются в приложении, в разделе
              «Автооткрытие».
            </p>
            <ol>
              <li>Открой приложение и нажми «Подключить сканер».</li>
              <li>Введи выданный одноразовый код здесь.</li>
              <li>Подготовь рабочее место в приложении.</li>
            </ol>
            <label>
              Код сопряжения
              <input
                value={code}
                maxLength={10}
                autoComplete="off"
                onChange={(e) => setCode(e.target.value)}
              />
            </label>
            <button
              disabled={busy || code.length !== 10}
              onClick={() => void pair()}
            >
              Подключить
            </button>
            <button disabled={busy} onClick={() => void migrate()}>
              Перенести назначения из Студии
            </button>
            <p role="status">{message}</p>
            <a href="https://forq.ru/downloads/proxy/current/FORQ-Proxy-Setup.exe">
              Скачать FORQ Proxy для Windows
            </a>
            <p>
              В браузере со сканером и профилях AdsPower нужно расширение FORQ
              0.4.140 или новее.
            </p>
          </div>
        </div>
      )}
    </>
  );
}
